<script lang="ts" setup>
import { computed } from "vue";

export interface TagItem {
  label: string;
  value: string | number;
}

interface FilteredTagItem extends TagItem {
  selected: boolean;
}

const props = withDefaults(
  defineProps<{
    list: TagItem[];
    selected: TagItem["value"][];
    // 是否将选中的排在最前面
    unshiftSelected?: boolean;
    // 是否有全选按钮: 全选按钮会清空selected
    enableAll?: boolean;
    wrap?: boolean;
    border?: boolean;
    enableMultiSelect?: boolean;
    shape?: "square" | "round";
    size?: "sm" | "xs";
    disabled?: boolean;
  }>(),
  {
    unshiftSelected: false,
    enableAll: false,
    wrap: false,
    enableMultiSelect: true,
    shape: "round",
    size: "sm",
    disabled: false,
  }
);

const emit = defineEmits<{
  (event: "update:selected", value: TagItem["value"][]): void;
}>();

const filteredList = computed(() => {
  if (!props.unshiftSelected) {
    return props.list.map((item) => ({
      ...item,
      selected: props.selected.includes(item.value),
    }));
  } else {
    const res = [] as FilteredTagItem[];
    for (const item of props.list) {
      const data: FilteredTagItem = {
        ...item,
        selected: props.selected.includes(item.value),
      };
      data.selected ? res.unshift(data) : res.push(data);
    }
    return res;
  }
});

const toggle = (item: FilteredTagItem) => {
  if (props.enableMultiSelect) {
    if (item.selected) {
      emit(
        "update:selected",
        props.selected.filter((v) => v !== item.value)
      );
    } else {
      emit("update:selected", props.selected.concat(item.value));
    }
  } else {
    emit("update:selected", [item.value]);
  }
};
</script>

<template>
  <div
    :class="{
      'overflow-x-auto no-scrollbar flex-nowrap': !wrap,
      'flex-wrap': wrap,
      'opacity-50 pointer-events-none': disabled,
    }"
    class="flex gap-1 items-center"
  >
    <div
      v-if="enableAll"
      :class="{
        'bg-primary text-primary-content': selected.length === 0,
        '': selected.length > 0,
        'border/20': border,
        'rounded-full': shape === 'round',
        rounded: shape === 'square',
      }"
      class="px-3 py-1 shrink-0 cursor-pointer"
      @click="emit('update:selected', [])"
    >
      {{ $t("Buttons.all") }}
    </div>
    <div
      v-for="item in filteredList"
      :key="item.label"
      :class="{
        'bg-primary text-primary-content': item.selected,
        '': !item.selected,
        'border/20': border,
        'rounded-full': shape === 'round',
        rounded: shape === 'square',
      }"
      class="px-3 py-1 shrink-0 cursor-pointer border"
      @click="toggle(item)"
    >
      {{ item.label }}
    </div>
  </div>
</template>
